// Tenant configuration. In a multi-tenant SaaS this object is resolved per host
// (e.g. structure subdomain) and returned by the API. Branding, colors, logo,
// language and navigation are all driven from here.

export const domiraBrand = {
  name: 'DOMIRA',
  suffix: 'SOLUTIONS',
  tagline: 'Smart solutions for modern hospitality'
};

export const tenant = {
  id: 'paelbi-demo',
  brand: {
    name: 'PAELBI',
    payoff: 'IL TUO B&B'
  },
  theme: {
    bg: '#F7F4F0',
    bg2: '#E9E2D7',
    accent: '#DCC6B7',
    brown: '#8B6F4E',
    ink: '#2B282B'
  },
  languages: ['IT', 'EN', 'DE', 'FR'],
  defaultLanguage: 'IT',
  contacts: {
    phone: '+39 123 456 7890',
    email: 'info@paelbi.it'
  }
};

// Guest platform navigation (PAELBI)
export const guestNav = [
  { label: 'Home', path: '/paelbi' },
  { label: 'Eventi', path: '/paelbi/eventi' },
  { label: 'Vicino a te', path: '/paelbi/vicino-a-te' },
  { label: 'Arte e Musei', path: '/paelbi/arte-musei' },
  { label: 'Servizi', path: '/paelbi/servizi' },
  { label: 'Esperienze', path: '/paelbi/esperienze' },
  { label: 'Info BnB', path: '/paelbi/info-bnb' }
];

// Domira commercial landing navigation
export const domiraNav = [
  { label: 'Funzionalit\u00e0', path: '#funzionalita' },
  { label: 'Prezzi', path: '#prezzi' },
  { label: 'Perch\u00e9 Domira', path: '#perche' },
  { label: 'Contatti', path: '#contatti' }
];

export const footerLinks = [
  { label: 'Privacy', path: '#' },
  { label: 'Termini', path: '#' },
  { label: 'Contatti', path: '#' }
];
